import React from 'react';
import { Card, withStyles } from '@material-ui/core';

import styles from './styles';


function InvoiceStatusCard({ classes, children, invoiceStatus }) {
  return (
    <Card elevation={1} className={`${classes.container} ${classes[invoiceStatus]}`}>
      {children}
    </Card>
  );
}

export default withStyles(styles, { withTheme: true })(InvoiceStatusCard);
